import { DatabaseId } from "@syla/shared/types/helpers/Id";
import { CreateSubscriptionRequestBody } from "@syla/shared/types/requests/CreateSubscriptionRequest";
import { CreateSubscriptionResponse } from "@syla/shared/types/responses/CreateSubscriptionResponse";
import axios from "axios";
import { throwSylaApiError } from "../errors/throwSylaApiError";

export async function createSubscription(
  accountId: DatabaseId,
  props: CreateSubscriptionRequestBody,
): Promise<CreateSubscriptionResponse> {
  try {
    const response = await axios.post(
      `/accounts/${accountId}/subscriptions/create-subscription`,
      props,
    );
    return response.data;
  } catch (error) {
    throwSylaApiError(error);
  }
}
